
import 'reflect-metadata';
import { Vue, Component, Prop, Watch, Model, Emit } from 'vue-property-decorator';
import { mask } from 'vue-the-mask';
import Util from '../../assets/utils/Util';
import TkSelect from '../fields/TkSelect.vue';
import TkDate from '../fields/TkDate.vue';
import TkDropdownPanel from '../TkDropdownPanel.vue';
import Dictionary from '../../assets/interfaces/Dictionary';
import { isCrudFieldRequired } from '../../assets/utils/crud';

@Component({
  components: {
    TkSelect,
    TkDate,
    TkDropdownPanel
  },
  directives: {
    // Customized directive to allow vue-the-mask to accept undefined masks
    mask: (el, binding) => {
      if (!binding.value) return;
      mask(el, binding);
    }
  },
  methods: {
    isCrudFieldRequired,
  },
})
class RowPopUp extends Vue {
  // MODEL
  @Model('changeVisibilty', { type: Boolean })
  private visible: boolean;

  // PROPS
  @Prop({ required: true })
  private columns: any[];

  @Prop({ required: true })
  private readonly name: string;

  @Prop({ default: {'__mode': 'edit', '__is_new': true} })
  private currentRow: Dictionary<any>;

  @Prop({ default: [] })
  private PopUpButtons: any[];

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: 700 })
  private readonly maxWidth: number | string;

  @Prop({ default: false })
  private readonly showAuditFields: boolean;

  // Lista de campos de auditoria
  private auditFieldNames = [
    'DTINCLUSAO',         // Incluído em
    'NMOPERINCLUSAO', // Incluído por
    'NRORGINCLUSAO',      // Org. Inclusão
    'DTULTATU',        // Atualizado em
    'NMOPERULTATU',// Atualizado por
    'NRORGULTATU'      // Org. Atualização
  ];
  // Propriedade computada para filtrar os campos de auditoria
  private get auditColumns(): any[] {
    return this.columns.filter(column => 
      this.auditFieldNames.includes(column.value)
    );
  }
  // Propriedade computada para filtrar os campos que não são de auditoria
  private get displayColumns(): any[] {
    return this.columns.filter(column => 
      !this.auditFieldNames.includes(column.value)
    );
  }
  

  //WATCH
  @Watch('visible')
  private visibleOnChange() {
    if (this.visible){
      this.resetInternalRow();
      this.applyOutDataAll();
    }
  }

  @Watch('currentRow', { immediate: true, deep: true })
  private setIntervalRow(row: Dictionary<any>) {
    this.resetInternalRow();
  }

  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.$forceUpdate();
  }

  @Watch('columns', {immediate: true})
  private columnsOnChange() {
    this.fetchColumnsOptions();
    this.applyOutDataAll();
  }

  @Emit('changeVisibilty')
  private changeVisibilty(): boolean {
    return false;
  }

  @Emit('change')
  private emitChange(field: string, value: any) {
    return [field, value];
  }

  //DATA
  private comumTags = [
    "tag",
    "showOnForm",
    "text",
    "value",
    "cols",
    "readonly",
    "defaultValue",
    "change",
    "mask"
  ];

  internalRow: Dictionary<any> = {};

  private backupRow: any = [];

  private fieldsOptions: Dictionary<any[]> = {};

  // METHODS
  private onClickAction(action: any) {
    if (action.onClick) {
      action.onClick();
    }
    this.attCurrentRow();
    action.action(this.internalRow);
  }

  private onChangeField(column: any){
    this.attCurrentRow();
    if(column.change){
      column.change(this.internalRow, this.columns);
    }

    this.emitChange(column.value, this.internalRow[column.value]);
  }

  private attCurrentRow(){
    Object.keys(this.$refs).forEach((key) => {
      const fieldArray = (this.$refs as any)[key];
      const keyNotExists = !Array.isArray(fieldArray) || fieldArray.length === 0;
      if (keyNotExists) {
        return;
      }

      const fieldReference = fieldArray[0];
      if(fieldReference.date)
        this.internalRow[key] = fieldReference.date;
      else{
        if(!!fieldReference.lazyValue)
        this.internalRow[key] = fieldReference.lazyValue;
      }
    });
  }

  private getBind(column: any){
    let bind = {};
    Object.entries(column).forEach((value)=> {
      if(!this.comumTags.includes(value[0])){
        (bind as any)[value[0]] = value[1];
      }
    });
    if(column.tag=='TkSelect'){
      (bind as any)['returnObject'] = true;
    }
    return bind;
  }

  private getValue(column: any){
    let value;
    if(column.tag=='TkSelect'){
      value = this.getSelectedValue(column);
    } else {
      value = this.internalRow[column.value] ? this.internalRow[column.value] : column.defaultValue;
    }
    return value;
  }

  private getSelectedValue(column: any){
    let selected: any = {};
    if(column.tag=='TkSelect'){
      if(this.internalRow[column.valueField]){
        selected[column.valueField] = this.internalRow[column.valueField];
        selected[column.descriptionField] = this.internalRow[column.descriptionField];
      }else{
        if(column.defaultValue){
          selected = column.defaultValue;
        } else {
          selected[column.valueField] = undefined;
          selected[column.descriptionField] = undefined;
        }
      }
      return selected;
    }
    return "";
  }

  // Rotina responsavel por alterar a Row em momentos de alteracao dos campos
  private updateSelectValue(event: any, column: any){
    // Verifica se o valor foi alterado e o campo eh um select
    if (!event && column.valueField && column.descriptionField) {
      event = {
        [column.descriptionField]: null,
        [column.valueField]: null
      };
    }

    // Caso seja um select, o valor do description e valueField serao adicionados a Row
    if (Util.isObject(event)) {
      for (let [key, value] of Object.entries(event)) {
        this.internalRow[key] = value;
      }
    } else {
      // Caso nao seja, o valor eh associado a coluna apenas
      this.internalRow[column.value] = event;
    }

    this.applyOutData(column);
  }

  /** Saves into the internal row the out-data properties of the selected item of the informed column. */
  private applyOutData(column: any) {
    if (!column.outData) return;

    const fieldOptions = this.fieldsOptions[column.value];

    if (!fieldOptions) return;

    const selectedOption = fieldOptions.find((option) =>
      option[column.valueField] === this.internalRow[column.valueField]);

    Object.keys(column.outData).forEach((outProp) => {
      this.internalRow[outProp] = selectedOption ? selectedOption[column.outData[outProp]] : null;
    });

    this.$forceUpdate();
  }

  /** Saves into the internal row the out-data properties of the selected items of all columns. */
  private applyOutDataAll() {
    this.columns.forEach((column) => this.applyOutData(column));
  }

  private closeDialog(){
    this.changeVisibilty();
  }

  /** Fetches the local (fixed) items of all columns (mainly "selects" and "autocompletes")
   * and saves them into a local variable to facilitate the access to them.
   */
  private fetchColumnsOptions() {
    this.columns.forEach((column) => {
      if (column.items) {
        this.fieldsOptions[column.value] = column.items;
      }
    });
  }

  private onFieldAfterReload(options: any[], column: any) {
    this.fieldsOptions[column.value] = options;
    this.applyOutData(column);
  }

  /** Resets the internal row to its original state. */
  private resetInternalRow() {
    this.internalRow = {...this.currentRow};
  }

  getFieldClass(column: any) {
    const showRequiredIcon = isCrudFieldRequired(this.internalRow, column) && !['TkDate', 'TkSelect'].includes(column.tag);

    return {
      'required-field': showRequiredIcon,
    };
  }
  private mounted() {
    // Adiciona um listener global para a tecla ESC
    window.addEventListener('keydown', this.handleGlobalEsc);
  }


  private handleGlobalEsc(event: KeyboardEvent) {
    // Verifica se a tecla pressionada é ESC e se o diálogo está visível
    if (event.key === 'Escape' && this.visible) {
      this.closeDialog();
    }
  }
}

export default RowPopUp;
